module.exports = __webpack_public_path__ + "img/cg_oldtown_live.040fd439.jpg";